import ApiService from './ApiService';

export default class RegionProvinceApi extends ApiService {
    getRegions(payload) {
        return this.get('regions', payload, { noUseToken: true });
    }

    getProvinces(payload) {
        return this.get('provinces', payload, { noUseToken: true });
    }

    getProvincesByRegion(payload) {
        return this.get('region-province', payload, { noUseToken: true });
    }

    getAllRegion(payload) {
        return this.get('region-province', payload);
    }

    getLocationsByRegionProvince(payload) {
        return this.get('customer/locations', payload);
    }
}
